export const AppFeatures=[
{
    name:"Tableau de bord admin",
    link:"/admin/dashboard",
    tag:"tdb-admin"
},
{
    name:"Gestion des années académiques",
    link:"/admin/configurations/academic-year",
    tag:"g-ay"
},
{
    name:"Gestion des paramètres d'école",
    link:"/admin/configurations/school",
    tag:"g-school-setting"
},
{
    name:"Gestion des paramètres généraux",
    link:"/admin/configurations/settings",
    tag:"g-general-settings"
},
{
    name:"Gestion des cycles",
    link:"/admin/configurations/cycles",
    tag:"g-cycles"
},
{
    name:"Gestion des salles",
    link:"/admin/configurations/rooms",
    tag:"g-rooms"
},
{
    name:"Gestion des périodes",
    link:"/admin/configurations/periods",
    tag:"g-periods"
},
{
    name:"Gestion des séries de classe",
    link:"/admin/configurations/levels",
    tag:"g-levels"
},{
    name:"Gestion des classes",
    link:"/admin/configurations/classrooms",
    tag:"g-classrooms"
},
{
    name:"Gestion des documents pour inscription",
    link:"/admin/configurations/documents",
    tag:"g-documents"
},
{
    name:"Organisation des documents par classe ",
    link:"/admin/configurations/inscription-files",
    tag:"g-ins-files"
},
{
    name:"Gestion des inscriptions par classe",
    link:"/admin/configurations/inscription-validations",
    tag:"g-ins-validation"
},
{
    name:"Gestion des matières",
    link:"/admin/configurations/courses",
    tag:"g-courses"
},
{
    name:"Gestion du personnel",
    link:"/admin/configurations/personals",
    tag:"g-personals"
},
{
    name:"Attricution des matières au professeurs",
    link:"/admin/professors/courses",
    tag:"g-prof-courses"
},
{
    name:"Gestion des professeurs",
    link:"/admin/professors/list",
    tag:"g-prof-list"
},
{
    name:"Assignation de matières au professeur par classe",
    link:"/admin/professors/classrooms",
    tag:"g-prof-classrooms"
},
{
    name:"Organisation des emplois",
    link:"/admin/timetable",
    tag:"g-prof-timetable"
},
{
    name:"Gestion des bulletins",
    link:"/admin/bulletins",
    tag:"g-bulletins"
},
{
    name:"Gestion des inscriptions",
    link:"/admin/inscription",
    tag:"g-inscription"
},
{
    name:"Gestion des utilisateurs",
    link:"/admin/users",
    tag:"g-users"
},
{
    name:"Gestion des rôles",
    link:"/admin/roles",
    tag:"g-roles"
},
{
    name:"Gestion des permissions",
    link:"/admin/permissions",
    tag:"g-permissions"
},
{
    name:"profiles",
    link:"/admin/profiles",
    tag:"g-profiles"
},
{
    name:"Gestion des notes",
    link:"/admin/note-index",
    tag:"g-note-index"
},
{
    name:"Gestion des compositions",
    link:"/admin/composition-index",
    tag:"g-composition-index"
},
{
    name:"Suivi des compositions",
    link:"/admin/composition-by-classrooms",
    tag:"g-composition-by-classrooms"
},
{
    name:"Tableau de bord Apprenant",
    link:"/child-module/accueil",
    tag:"tdb-child"
},
{
    name:"Gestion du compte apprenant",
    link:"/child-module/student-account",
    tag:"g-student-account"
},
{
    name:"Consultation des ressources apprenant",
    link:"/child-module/student-docs",
    tag:"g-student-docs"
},
{
    name:"Consultation du cahier de texte apprenant",
    link:"/child-module/textbooks",
    tag:"g-student-textbooks"
},
{
    name:"Consultation de notes apprenant",
    link:"/child-module/notes",
    tag:"g-student-notes"
},
{
    name:"Consultation donnée de classe",
    link:"/child-module/classroom-infos",
    tag:"g-student-classroom-infos"
},
{
    name:"Inbox apprenant",
    link:"/child-module/inbox",
    tag:"g-student-inbox"
},
{
    name:"Consultation de l'agenda apprenant",
    link:"/child-module/agenda",
    tag:"g-student-agenda"
},{
    name:"Consultation des fora",
    link:"/child-module/educational-fora",
    tag:"g-student-educational-fora"
},
{
    name:"Tableau de bord professeur",
    link:"/professor-module/accueil",
    tag:"tdb-professor"
},
{
    name:"Consultation d'emploi du temps",
    link:"/professor-module/timetables",
    tag:"g-professor-timetables"
},
{
    name:"Consultation des listes apprenant par classe",
    link:"/professor-module/claasroom-students-list",
    tag:"g-professor-claasroom-students-list"
},
{
    name:"Consultation des listes professors par classe",
    link:"/professor-module/claasroom-professors-list",
    tag:"g-professor-claasroom-professors-list"
},
{
    name:"Consultation de la liste du personel | vue enseigant",
    link:"/professor-module/professors-personal-list",
    tag:"g-professors-personal-list"
},
{
    name:"Consultation des appréciation",
    link:"/professor-module/professors-appreciation",
    tag:"g-professors-appreciation"
},
{
    name:"Gestion de compte | vue enseignant",
    link:"/professor-module/professors-account",
    tag:"g-professor-professors-account"
},
{
    name:"Gestion des ressources | vue enseigant",
    link:"/professor-module/educational-resources",
    tag:"g-professor-educational-resources"
},
{
    name:"Gestion de fora édiucatifs | vue enseignant",
    link:"/professor-module/educational-forum",
    tag:"g-educational-forum"
},
{
    name:"Gestion du cahier de texte",
    link:"/professor-module/textbook",
    tag:"g-professor-textbook"
},
{
    name:"Gestion des devoirs de maison",
    link:"/professor-module/tasklists",
    tag:"g-professor-tasklists"
},
{
    name:"Consultation des devoirs de maison",
    link:"/professor-module/tasklists-student-view",
    tag:"g-professor-tasklists-student-view"
},
{
    name:"Saisie de note",
    link:"/professor-module/note-create",
    tag:"g-professor-note-create"
},
{
    name:"Consultation de note",
    link:"/professor-module/",
    tag:"g-professor-note-index"
}
]